import { TOGGLE_THEME, SET_THEME } from '../types';

export default (state, action) => {
  switch (action.type) {
    case TOGGLE_THEME:
      return {
        ...state,
        isDarkMode: !state.isDarkMode
      };
    case SET_THEME:
      return {
        ...state,
        isDarkMode: action.payload
      };
    default:
      return state;
  }
};